export const EDITOR = "Editor";
export const APPROVER = "Approver";
export const EXPORTER = "Exporter";
export const PULLER = "Puller";
export const VIEWER = "Viewer";
